var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.toasts),function(item,index){return _c('div',{key:'toast_' + item.timestamp,staticClass:"toast"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }